export const ROUTE_ENDPOINTS = {
  LOGIN: "/login",
  HOME: "/home/*",
  HOME_CUSTOMERS: "/home/customers",
  HOME_CATEGORIES: "/home/categories",
  HOME_STORES: "/home/stores",
  HOME_PRODUCTS: "/home/products",
  HOME_ORDERS: "/home/orders",
  HOME_TRANSACTIONS: "/home/transactions",
  CUSTOMERS: "/customers",
  CATEGORIES: "/categories",
  STORES: "/stores",
  PRODUCTS: "/products",
  ORDERS: "/orders",
  TRANSACTIONS: "/transactions",
};

export const ROUTE_NEW = "new";
